<template>
    <div id="app">
        <nav class="navbar navbar-expand-md navbar-light navbar-laravel">
            <div class="container">
                <router-link :to="{ name: 'home' }" class="navbar-brand">
                    <img
                        src="https://vo.ecologic.sk/img/eco_logo.png"
                        width="110"
                        alt=""
                        class="d-inline-block align-top"
                    />
                </router-link>
                <button
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    class="navbar-toggler"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div
                    id="navbarSupportedContent"
                    class="collapse navbar-collapse"
                >
                    <ul class="navbar-nav mr-auto"></ul>
                    <ul class="navbar-nav ml-auto">
                        <!--                        <li>-->
                        <!--                            <router-link-->
                        <!--                                :to="{-->
                        <!--                                    name: 'reportdefect',-->
                        <!--                                    params: { city: 'senec', point: '123' }-->
                        <!--                                }"-->
                        <!--                                class="nav-link"-->
                        <!--                                >Nahlásiť poruchu-->
                        <!--                            </router-link>-->
                        <!--                        </li>-->
                        <li v-if="$can('map.basic.show')">
                            <router-link
                                :to="{ name: 'dashboard' }"
                                class="nav-link"
                            >
                                Základná mapa
                            </router-link>
                        </li>
                        <li v-if="$can('map.technic.show')">
                            <router-link
                                :to="{
                                    name: 'dashboard',
                                    params: { mapType: 'defect' }
                                }"
                                class="nav-link"
                            >
                                Mapa technik
                            </router-link>
                        </li>
                        <li v-if="$can('map.rescue.show')">
                            <router-link
                                :to="{
                                    name: 'dashboard',
                                    params: { mapType: 'rescue' }
                                }"
                                class="nav-link"
                            >
                                Mapa záchranár
                            </router-link>
                        </li>
                        <b-nav-item-dropdown text="Poruchy" v-if="$can('reported.defects')">
                            <b-dropdown-item :to="{ name: 'defects' }">Nahlásené poruchy</b-dropdown-item>
                            <b-dropdown-item :to="{ name: 'defectsHistory' }">História porúch</b-dropdown-item>
                        </b-nav-item-dropdown>


                        <li v-if="$can('administration.show')">
                            <router-link
                                :to="{ name: 'administration' }"
                                class="nav-link"
                                >Administrácia
                            </router-link>
                        </li>
                        <li>
                            <a href="#" @click.prevent="logout" class="nav-link"
                                >Logout</a
                            >
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <main class="LayoutFull__main">
            <router-view />
        </main>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    computed: {
        user() {
            return this.$store.getters.getProfile;
        }

        // csrf() {
        //     return window.Laravel.csrfToken;
        // }
    },
    methods: {
        logout: function() {
            this.$store.dispatch("authLogout").then(() => {
                this.$router.push("/");
            });
        }
    }
};
</script>

<style lang="scss"></style>
